










import { Component, Vue } from "vue-property-decorator";
import { NavigationLink } from "@/types/NavigationLink";
import NavigationBar from "@/components/layout/navigation/NavigationBar.vue";
import NavigationDrawer from "@/components/layout/navigation/NavigationDrawer.vue";

@Component({
    components: { NavigationDrawer, NavigationBar }
})
export default class Navigation extends Vue {
    /**
     * Should the drawer be open.
     */
    drawer = false;

    /**
     * Links to display inside the navigation bar
     */
    links: Array<NavigationLink> = [
        {
            text: "Home",
            to: "/",
            icon: "mdi-home"
        },

        {
            text: "Geschiedenis",
            to: "/geschiedenis",
            icon: "mdi-book-open-page-variant"
        },

        {
            text: "Praesidium",
            to: "/praesidium",
            icon: "mdi-account"
        },
/**
        {
            text: "OG",
            to: "/og",
            icon: "mdi-account"
        },
**/
        {
            text: "Clublied",
            to: "/clublied",
            icon: "mdi-music"
        },

        {
            text: "Kalender",
            to: "/kalender",
            icon: "mdi-calendar"
        }
    ];
}
